(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["benefits-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    $('.js-productSlides').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
      adaptiveHeight: true,
      autoplay: true,
      autoplaySpeed: 4000,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["category-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    $('.js-productSlides').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
      adaptiveHeight: true,
      autoplay: true,
      autoplaySpeed: 4000,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-suppliers"]) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    $('.js-productSlides').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
      adaptiveHeight: true,
      autoplay: true,
      autoplaySpeed: 4000,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);



  // underlines for nav on click
document.addEventListener('DOMContentLoaded', () => {
  const navItems = document.querySelectorAll('.nav-item');
  const dropdown = document.getElementById('sharedDropdown');

  navItems.forEach(item => {
    const type = item.getAttribute('data-type');

    item.querySelector('a.nav-link').addEventListener('click', (e) => {
      e.preventDefault();

      // Remove active class from all nav items
      navItems.forEach(i => i.classList.remove('active'));

      // Add active to clicked nav item
      item.classList.add('active');

      // Show relevant dropdown content
      document.querySelectorAll('#sharedDropdown .dropdown-content').forEach(dc => {
        if (dc.getAttribute('data-type') === type) {
          dc.style.display = 'block';
        } else {
          dc.style.display = 'none';
        }
      });
    });
  });

  // Hide active on clicking outside
  document.addEventListener('click', (e) => {
    if (!dropdown.contains(e.target) && !e.target.closest('.nav-item')) {
      navItems.forEach(i => i.classList.remove('active'));
      document.querySelectorAll('#sharedDropdown .dropdown-content').forEach(dc => {
        dc.style.display = 'none';
      });
    }
  });
});



new MutationObserver(function(_, observer) {
  var province = document.querySelector('label[for="address_province"]');
  var zip = document.querySelector('label[for="address_zipcode"]');
  if (province) province.textContent = 'County';
  if (zip) zip.textContent = 'Postcode';
  if (province && zip) observer.disconnect();
}).observe(document.body, { childList: true, subtree: true });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["heating-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    $('.js-productSlides').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
      adaptiveHeight: true,
      autoplay: true,
      autoplaySpeed: 4000,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["inspiration-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  $('.js-productSlides').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    adaptiveHeight: true,
    autoplay: true,
    autoplaySpeed: 4000,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["labelled-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    $('.labelled-slides').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      adaptiveHeight: true,
      autoplay: false,
      autoplaySpeed: 4000,
      prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="13.95" height="22.277" viewBox="0 0 13.95 22.277"><g id="Group_1693" data-name="Group 1693" transform="translate(912.196 553.124) rotate(180)"><path id="Path_511" data-name="Path 511" d="M0,0,11.769,10.633,0,20.778" transform="translate(898.916 531.588)" fill="none" stroke="#fff" stroke-width="2"/></g></svg></button>',
      nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="13.95" height="22.277" viewBox="0 0 13.95 22.277"><g id="Group_1692" data-name="Group 1692" transform="translate(-898.245 -530.846)"><path id="Path_511" data-name="Path 511" d="M0,0,11.769,10.633,0,20.778" transform="translate(898.916 531.588)" fill="none" stroke="#fff" stroke-width="2"/></g></svg></button>'
    });

    $('.product-box').hide();


    $('.labelled-slides').on('click', '.label', function() {
      var idx = $(this).data('slide-index');
      var $slide = $('.labelled-slide[data-slide-index="' + idx + '"]');
      var $box = $slide.find('.product-box');


      $box.toggle();

      $('.product-box');
      $box.fadeIn(300);
    });

    // Hide product-box when clicking outside labels or product-box
    document.addEventListener('click', function (event) {
      const isLabel = event.target.closest('.label');
      const isProductBox = event.target.closest('.product-box');

      if (!isLabel && !isProductBox) {
        document.querySelectorAll('.product-box').forEach(box => {
          box.style.display = 'none';
        });
      }
    });

  });



  document.addEventListener('click', function (e) {
    const label = e.target.closest('.label');

    document.querySelectorAll('.product-box').forEach(box => box.style.display = 'none');

    // if label on right side, display product box to left, if label on top half, show product box on bottom

    if (label) {
      const slide = label.closest('.labelled-slide');
      const labelNumber = label.getAttribute('data-label');
      const productBox = slide.querySelector('.product-box[data-label="' + labelNumber + '"]');

      if (productBox) {
        const slideWidth = slide.offsetWidth;
        const slideHeight = slide.offsetHeight;
        const labelX = label.offsetLeft;
        const labelY = label.offsetTop;
        const labelCenterX = labelX + label.offsetWidth / 2;
        const labelCenterY = labelY + label.offsetHeight / 2;
        let left, top;

        if (labelCenterX > slideWidth / 2) {
          left = labelX - productBox.offsetWidth - 350;
        } else {
          left = labelX + label.offsetWidth + 0;
        }

        if (labelCenterY > slideHeight / 2) {
          top = labelY - productBox.offsetHeight - 150;
        } else {
          top = labelY + label.offsetHeight + 10;
        }

        productBox.style.position = 'absolute';
        productBox.style.left = `${left}px`;
        productBox.style.top = `${top}px`;
        productBox.style.display = 'flex';
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["logo-carousel"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    if (typeof jQuery !== 'undefined' && typeof jQuery.fn.slick !== 'undefined') {
      $('.js-productSlides').not('.slick-initialized').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        adaptiveHeight: true,
        autoplay: true,
        autoplaySpeed: 4000,
        responsive: [
          {
            breakpoint: 1024,
            settings: { slidesToShow: 2 }
          },
          {
            breakpoint: 600,
            settings: { slidesToShow: 1 }
          }
        ]
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    $('.js-productSlides').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
      adaptiveHeight: true,
      autoplay: true,
      autoplaySpeed: 4000,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    // PBD Oct 2026: only target this section's carousel – a page-wide $('.carousel') also hit the
    // Shop by category slider on the homepage, errored, and left the reviews un-initialised
    $('section.reviews .carousel').not('.slick-initialized').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
      adaptiveHeight: true,
      autoplay: true,
      autoplaySpeed: 4000
    });
  });

  } catch(e) { console.error(e); }
})();
})();
